<!-- Sans image, un fond plein vert foncé (environ 9:1 avec le texte blanc) ;
     avec image, un dégradé d'encre en bas de carte au lieu d'un voile vert sur
     toute la photo (A8). -->
<div class="relative flex cursor-pointer flex-col justify-end gap-2 overflow-hidden rounded-card bg-vw-primary-ink"
  [ngClass]="compact ? 'p-3 min-h-[200px]' : 'p-4 min-h-36'" (click)="onArticleClicked(article.id)" data-test="article-card">
  @if (article.image) {
    <!-- Fond vert pâle sous la photo : un PNG détouré de la boutique ne laisse
         plus voir le vert foncé de la carte sur ses bords (M5). -->
    <img [src]="article.image.src" alt="" class="absolute inset-0 z-0 h-full w-full bg-vw-surface-tint object-cover" data-test="article-image">
    <div class="article-card__veil absolute inset-0 z-10" data-test="article-veil"></div>
  }
  <div class="relative z-20 flex flex-col gap-1">
    <h3 class="line-clamp-3 font-semibold text-vw-on-color" [ngClass]="compact ? 'text-body' : 'text-title-s'">
      {{ title }}
    </h3>
    @if (tagKeys.length > 0 || article.publishedAt) {
      <div class="flex flex-wrap items-center gap-1">
        @for (key of tagKeys; track key) {
          <span class="rounded-pill bg-vw-surface px-2 py-0.5 text-caption text-vw-primary-ink" data-test="article-tag">{{ key | translate }}</span>
        }
        @if (article.publishedAt) {
          <span class="text-caption text-vw-on-color" data-test="article-date">{{ article.publishedAt | vwDate: 'short' }}</span>
        }
      </div>
    }
  </div>
</div>
